import el from "@cypherpotato/el";
import { displayAlert } from "./alert";
import { Paragraph } from "../components/text";
import { DiffViewer } from "../components/diff-viewer";

export function acceptDiff(original, modified) {

    return new Promise((resolve, reject) => {

        displayAlert({
            title: "Review changes",
            dialogSize: "large",
            message: el.fragment(
                Paragraph("Please, review the changes below before continuing."),
                DiffViewer({
                    textA: original,
                    textB: modified
                })
            ),
            buttons: [
                {
                    label: "Accept",
                    classList: ["primary"],
                    onClick() {
                        resolve(modified);
                    }
                },
                {
                    label: "Cancel",
                    onClick() {
                        reject();
                    }
                }
            ]
        })
    });
}